import React, { useState } from 'react';
import { Card, Form, Input, Button, Alert, Typography, Segmented, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import api, { setToken } from '../api';
import { useI18n } from '../i18n';

// 登录页：用户名 + 密码 → 取回 JWT 存 localStorage，成功后回调 onLoggedIn
const Login = ({ onLoggedIn }) => {
  const { t, ts, lang, setLang } = useI18n();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async ({ username, password }) => {
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/login', { username, password });
      setToken(res.data.data.token);
      onLoggedIn(res.data.data);
    } catch (err) {
      setError(ts(err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5',
        padding: 16
      }}
    >
      <Card style={{ width: 380, maxWidth: '100%' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography.Title level={3} style={{ margin: 0 }}>
              Swap Bot
            </Typography.Title>
            <Segmented
              size="small"
              value={lang}
              onChange={setLang}
              options={[
                { label: '中', value: 'zh' },
                { label: 'EN', value: 'en' }
              ]}
            />
          </div>
          <Typography.Text type="secondary">{t('请登录以继续')}</Typography.Text>
          {error && <Alert type="error" showIcon message={error} />}
          <Form layout="vertical" onFinish={handleSubmit} requiredMark={false}>
            <Form.Item
              name="username"
              label={t('用户名')}
              rules={[{ required: true, message: t('请输入用户名') }]}
            >
              <Input prefix={<UserOutlined />} placeholder={t('用户名')} autoComplete="username" size="large" />
            </Form.Item>
            <Form.Item
              name="password"
              label={t('密码')}
              rules={[{ required: true, message: t('请输入密码') }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder={t('密码')}
                autoComplete="current-password"
                size="large"
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              {t('登录')}
            </Button>
          </Form>
        </Space>
      </Card>
    </div>
  );
};

export default Login;
